<template>
    <v-layout class="justify-center">
        <v-flex xs12 sm12 md10>
            <v-data-table
                :headers="headers"
                :items="messageGroups"
                :search="search"
                sort-by="messageGroup"
                class="elevation-6"
            >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Message Group Lookup</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical />
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                        />
                        <v-divider class="mx-4" inset vertical />
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    color="primary"
                                    dark
                                    class="mb-2"
                                    v-on="on"
                                >
                                    Quick Add
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{
                                        formTitle
                                    }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12 sm6 md4>
                                                <v-text-field
                                                    v-model="
                                                        editedItem.messageGroup
                                                            .messageGroup
                                                    "
                                                    label="Group Name"
                                                />
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer />
                                    <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="close"
                                        >Cancel</v-btn
                                    >
                                    <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="save"
                                        >{{ formSaveButton }}</v-btn
                                    >
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-divider class="mx-2" inset vertical />
                        <v-menu transition="slide-x-transition" bottom right>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item
                                    v-for="(item, i) in createListItems"
                                    :key="i"
                                    :to="item.route"
                                >
                                    <v-list-item-title>{{
                                        item.title
                                    }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-layout row>
                        <v-flex xs6>
                            <v-btn
                                x-small
                                text
                                color="warning"
                                @click="editItem(item)"
                            >
                                <v-icon small>
                                    edit
                                </v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex xs6>
                            <v-btn
                                x-small
                                text
                                color="info"
                                :to="`/message-group/view/${item.uid}`"
                            >
                                <v-icon small>
                                    remove_red_eye
                                </v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </template>
                <template v-slot:no-data>
                    <v-btn
                        class="jestTest"
                        color="primary"
                        @click="getMessageGroups"
                        >Retry</v-btn
                    >
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: 'MessageGroupLookup',
    props: {
        messageGroups: {
            type: Array,
            required: true,
            default: () => ({ uid: '', messageGroup: '' })
        }
    },
    data() {
        return {
            dialog: false,
            createListItems: [
                { title: 'Add Group', route: '/message-group/create' }
            ],
            search: '',
            headers: [
                {
                    text: 'Group Name',
                    align: 'center',
                    value: 'messageGroup'
                },
                {
                    text: 'Actions',
                    align: 'center',
                    value: 'action',
                    sortable: false
                }
            ],
            editedIndex: -1,
            editedItem: {
                messageGroup: { uid: '', messageGroup: '' }
            },
            defaultItem: {
                messageGroup: { uid: '', messageGroup: '' }
            }
        };
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'Quick Add' : 'Quick Edit';
        },
        formSaveButton() {
            return this.editedIndex === -1 ? 'Add' : 'Save';
        },
        messageGroup: function() {
            return this.$store.getters.getMessageGroupByUid(this.uid);
        }
    },
    watch: {
        dialog(val) {
            val || this.close();
        }
    },
    methods: {
        getMessageGroups() {
            this.$store.dispatch('messageGroupRead');
        },

        editItem(item) {
            this.editedIndex = this.messageGroups.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem(item) {
            const index = this.messageGroups.indexOf(item);
            confirm('Are you sure you want to delete this item?') &&
                this.messageGroups.splice(index, 1);
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                Object.assign(
                    this.messageGroups[this.editedIndex],
                    this.editedItem
                );
            } else {
                this.messageGroups.push(this.editedItem);
            }
            this.close();
        }
    }
};
</script>
